(function () {
  'use strict';

  var config = window.TruckHQVehicleSelectorConfig || {};
  var UNIVERSAL = config.universalValue || 'Universal';
  var UNIVERSAL_ENABLED = config.universalEnabled === true;
  var STORAGE_KEY = config.storageKey || 'truckhq:selected-vehicle:v1';
  var lastDialogTrigger = null;
  var lockedScrollY = 0;

  var VEHICLES = [
    {
      id: 'chevrolet',
      label: 'Chevrolet',
      filterValues: ['Chevrolet', 'GM'],
      models: [
        { id: 'colorado', label: 'Colorado', filterValues: ['Colorado', 'Canyon/Colorado'] },
        { id: 'silverado-1500', label: 'Silverado 1500', filterValues: ['Silverado 1500', 'Silverado 1500/2500/3500'] },
        { id: 'silverado-2500-3500', label: 'Silverado 2500 / 3500', filterValues: ['Silverado 2500/3500', 'Sierra/Silverado 2500/3500', 'Sierra/Silverado', 'Silverado 1500/2500/3500'] },
        { id: 'silverado-ev', label: 'Silverado EV', filterValues: ['Silverado EV'] }
      ]
    },
    {
      id: 'ford',
      label: 'Ford',
      filterValues: ['Ford'],
      models: [
        { id: 'bronco', label: 'Bronco', filterValues: ['Bronco'] },
        { id: 'f-150', label: 'F-150', filterValues: ['F-150', 'F-150 / F-250 / F-350'] },
        { id: 'f-250-f-350', label: 'F-250 / F-350', filterValues: ['F-250 / F-350', 'F-250/F-350', 'F-150 / F-250 / F-350', 'F-250/350/450/550'] },
        { id: 'maverick', label: 'Maverick', filterValues: ['Maverick'] },
        { id: 'ranger', label: 'Ranger', filterValues: ['Ranger'] }
      ]
    },
    {
      id: 'gmc',
      label: 'GMC',
      filterValues: ['GMC', 'GM'],
      models: [
        { id: 'canyon', label: 'Canyon', filterValues: ['Canyon', 'Canyon/Colorado'] },
        { id: 'sierra-1500', label: 'Sierra 1500', filterValues: ['Sierra 1500', 'Sierra 1500/2500/3500'] },
        { id: 'sierra-2500-3500', label: 'Sierra 2500 / 3500', filterValues: ['Sierra 2500/3500', 'Sierra/Silverado 2500/3500', 'Sierra/Silverado', 'Sierra 1500/2500/3500'] }
      ]
    },
    {
      id: 'honda',
      label: 'Honda',
      filterValues: ['Honda'],
      models: [
        { id: 'ridgeline', label: 'Ridgeline', filterValues: ['Ridgeline'] }
      ]
    },
    {
      id: 'jeep',
      label: 'Jeep',
      filterValues: ['Jeep'],
      models: [
        { id: 'gladiator', label: 'Gladiator', filterValues: ['Gladiator'] },
        { id: 'wrangler', label: 'Wrangler', filterValues: ['Wrangler'] }
      ]
    },
    {
      id: 'nissan',
      label: 'Nissan',
      filterValues: ['Nissan'],
      models: [
        { id: 'frontier', label: 'Frontier', filterValues: ['Frontier'] },
        { id: 'titan', label: 'Titan', filterValues: ['Titan'] }
      ]
    },
    {
      id: 'ram',
      label: 'Ram',
      filterValues: ['Dodge'],
      models: [
        { id: 'ram-1500', label: '1500', filterValues: ['Ram 1500', 'Ram 1500/2500/3500', 'Ram 1500/RamBox', 'Ram 1500/2500/3500/RamBox'] },
        { id: 'ram-2500-3500', label: '2500 / 3500', filterValues: ['Ram 2500/3500', 'Ram 1500/2500/3500', 'Ram 1500/2500/3500/RamBox'] },
        { id: 'ram-1500-rambox', label: '1500 with RamBox', filterValues: ['Ram (with ram box)', 'Ram 1500/RamBox', 'Ram 1500/2500/3500/RamBox'] }
      ]
    },
    {
      id: 'toyota',
      label: 'Toyota',
      filterValues: ['Toyota'],
      models: [
        { id: 'tacoma', label: 'Tacoma', filterValues: ['Tacoma'] },
        { id: 'tundra', label: 'Tundra', filterValues: ['Tundra'] }
      ]
    }
  ];

  function findMake(makeId) {
    return VEHICLES.find(function (make) { return make.id === makeId; });
  }

  function findModel(make, modelId) {
    if (!make) return null;
    return make.models.find(function (model) { return model.id === modelId; });
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function unique(values) {
    return values.filter(function (value, index, list) {
      return value && list.indexOf(value) === index;
    });
  }

  function getState(makeId, modelId) {
    var make = findMake(makeId);
    var model = findModel(make, modelId);
    if (!make || !model) return null;
    return { version: 1, makeId: make.id, modelId: model.id };
  }

  function loadState() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      return parsed ? getState(parsed.makeId, parsed.modelId) : null;
    } catch (error) {
      return null;
    }
  }

  function storeState(state) {
    try {
      if (state) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      // Storage can be unavailable in privacy modes. Filtering still works for this visit.
    }
  }

  function stateDetails(state) {
    if (!state) return null;
    var make = findMake(state.makeId);
    var model = findModel(make, state.modelId);
    if (!make || !model) return null;
    var makeFilterValues = unique(make.filterValues.concat(UNIVERSAL_ENABLED ? [UNIVERSAL] : []));
    var modelFilterValues = unique(model.filterValues.concat(UNIVERSAL_ENABLED ? [UNIVERSAL] : []));
    return {
      make: make,
      model: model,
      label: make.label + ' ' + model.label,
      makeFilterValues: makeFilterValues,
      modelFilterValues: modelFilterValues,
      makeFilterValue: makeFilterValues.join(','),
      modelFilterValue: modelFilterValues.join(',')
    };
  }

  function splitParamValues(searchParams, paramName) {
    if (!paramName) return [];
    return searchParams.getAll(paramName).reduce(function (values, entry) {
      return values.concat(String(entry || '').split(','));
    }, []).map(function (value) { return value.trim(); }).filter(Boolean);
  }

  function intersects(left, right) {
    var normalizedRight = right.map(normalize);
    return left.some(function (value) { return normalizedRight.indexOf(normalize(value)) !== -1; });
  }

  function inferStateFromUrl(url) {
    var makeValues = splitParamValues(url.searchParams, config.makeParam).filter(function (value) {
      return normalize(value) !== normalize(UNIVERSAL);
    });
    var modelValues = splitParamValues(url.searchParams, config.modelParam).filter(function (value) {
      return normalize(value) !== normalize(UNIVERSAL);
    });
    var matches = [];

    if (!makeValues.length || !modelValues.length) return null;

    VEHICLES.forEach(function (make) {
      if (!intersects(make.filterValues, makeValues)) return;
      make.models.forEach(function (model) {
        var score = model.filterValues.filter(function (value) {
          return modelValues.map(normalize).indexOf(normalize(value)) !== -1;
        }).length;
        if (score) matches.push({ state: getState(make.id, model.id), score: score });
      });
    });

    matches.sort(function (left, right) { return right.score - left.score; });
    if (!matches.length || (matches[1] && matches[0].score === matches[1].score)) return null;
    return matches[0].state;
  }

  function urlWithVehicle(target, state) {
    var details = stateDetails(state);
    var url = target instanceof URL ? target : new URL(target, window.location.origin);
    if (!details || !config.makeParam || !config.modelParam) return url;

    url.searchParams.delete(config.makeParam);
    url.searchParams.delete(config.modelParam);
    details.makeFilterValues.forEach(function (value) {
      url.searchParams.append(config.makeParam, value);
    });
    details.modelFilterValues.forEach(function (value) {
      url.searchParams.append(config.modelParam, value);
    });
    url.searchParams.delete('page');
    return url;
  }

  function urlHasCompleteVehicle(target, state) {
    var details = stateDetails(state);
    var url = target instanceof URL ? target : new URL(target, window.location.origin);
    if (!details) return false;

    var currentMakeValues = splitParamValues(url.searchParams, config.makeParam).map(normalize);
    var currentModelValues = splitParamValues(url.searchParams, config.modelParam).map(normalize);
    var expectedMakeValues = details.makeFilterValues.map(normalize);
    var expectedModelValues = details.modelFilterValues.map(normalize);

    return expectedMakeValues.every(function (value) {
      return currentMakeValues.indexOf(value) !== -1;
    }) && expectedModelValues.every(function (value) {
      return currentModelValues.indexOf(value) !== -1;
    });
  }

  function urlWithoutVehicle(target) {
    var url = target instanceof URL ? target : new URL(target, window.location.origin);
    if (config.makeParam) url.searchParams.delete(config.makeParam);
    if (config.modelParam) url.searchParams.delete(config.modelParam);
    url.searchParams.delete('page');
    return url;
  }

  function isListingPage() {
    return config.pageType === 'collection' || config.pageType === 'search';
  }

  function saveVehicleToCart(state) {
    if (!config.cartUpdateUrl || !window.fetch) return;
    var details = stateDetails(state);
    window.fetch(config.cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Selected Truck': details ? details.label : ''
        }
      })
    }).catch(function () {});
  }

  function fillMakeOptions(select) {
    var current = select.value;
    select.innerHTML = '<option value="">Select make</option>';
    VEHICLES.forEach(function (make) {
      var option = document.createElement('option');
      option.value = make.id;
      option.textContent = make.label;
      select.appendChild(option);
    });
    if (findMake(current)) select.value = current;
  }

  function fillModelOptions(select, makeId, selectedModelId) {
    var make = findMake(makeId);
    select.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = make ? 'Select model' : 'Select make first';
    select.appendChild(placeholder);

    if (!make) {
      select.disabled = true;
      return;
    }

    make.models.forEach(function (model) {
      var option = document.createElement('option');
      option.value = model.id;
      option.textContent = model.label;
      select.appendChild(option);
    });

    select.disabled = false;
    if (findModel(make, selectedModelId)) select.value = selectedModelId;
  }

  function syncForms(state) {
    document.querySelectorAll('[data-thq-vehicle-form]').forEach(function (form) {
      var makeSelect = form.querySelector('[data-thq-vehicle-make]');
      var modelSelect = form.querySelector('[data-thq-vehicle-model]');
      var clearButton = form.querySelector('[data-thq-clear-vehicle]');
      if (!makeSelect || !modelSelect) return;

      fillMakeOptions(makeSelect);
      makeSelect.value = state ? state.makeId : '';
      fillModelOptions(modelSelect, makeSelect.value, state ? state.modelId : '');
      if (clearButton) clearButton.hidden = !state;
    });
  }

  function syncHeader(state) {
    var details = stateDetails(state);
    var homepageSelector = document.querySelector('[data-thq-vehicle-selector-home]');
    document.querySelectorAll('.thq-vehicle-header').forEach(function (button) {
      var mobileHeader = button.closest('.thq-vehicle-header-mobile');
      var hideMobileHeader = Boolean(mobileHeader && (homepageSelector || (isListingPage() && details)));
      if (mobileHeader) mobileHeader.hidden = hideMobileHeader;
      button.hidden = hideMobileHeader || (!details && Boolean(homepageSelector));
      button.classList.toggle('has-vehicle', Boolean(details));
      var label = button.querySelector('[data-thq-header-label]');
      var value = button.querySelector('[data-thq-header-vehicle]');
      if (label) label.textContent = details ? 'My truck' : 'Shop by vehicle';
      if (value) value.textContent = details ? details.label : 'Select your vehicle';
      button.setAttribute('aria-label', details ? 'My truck: ' + details.label + '. Change vehicle.' : 'Select my vehicle');
    });
  }

  function syncHomeSelector(state) {
    var details = stateDetails(state);
    document.querySelectorAll('[data-thq-vehicle-selector-home]').forEach(function (section) {
      var prompt = section.querySelector('[data-thq-home-mobile-expand]');
      var saved = section.querySelector('[data-thq-home-mobile-saved]');
      var savedLabel = section.querySelector('[data-thq-home-mobile-saved-label]');

      section.classList.toggle('has-saved-vehicle', Boolean(details));
      if (details) section.classList.remove('is-mobile-expanded');
      if (prompt) {
        prompt.hidden = Boolean(details);
        prompt.setAttribute('aria-expanded', section.classList.contains('is-mobile-expanded') ? 'true' : 'false');
      }
      if (saved) saved.hidden = !details;
      if (savedLabel) savedLabel.textContent = details ? details.label : '';
    });
  }

  function syncInterface(state) {
    syncForms(state);
    syncHeader(state);
    syncHomeSelector(state);
  }

  function bindForm(form) {
    if (form.dataset.thqBound === 'true') return;
    form.dataset.thqBound = 'true';

    var makeSelect = form.querySelector('[data-thq-vehicle-make]');
    var modelSelect = form.querySelector('[data-thq-vehicle-model]');
    var feedback = form.querySelector('[data-thq-vehicle-feedback]');

    function resetFeedback() {
      if (!feedback) return;
      feedback.textContent = '';
      feedback.classList.remove('is-success');
    }

    makeSelect.addEventListener('change', function () {
      fillModelOptions(modelSelect, makeSelect.value, '');
      resetFeedback();
    });

    modelSelect.addEventListener('change', resetFeedback);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var nextState = getState(makeSelect.value, modelSelect.value);

      if (!nextState) {
        if (feedback) {
          feedback.classList.remove('is-success');
          feedback.textContent = 'Please choose both a make and model.';
        }
        if (!makeSelect.value) makeSelect.focus();
        else modelSelect.focus();
        return;
      }

      storeState(nextState);
      saveVehicleToCart(nextState);
      syncInterface(nextState);

      var context = form.getAttribute('data-context');
      if (context === 'homepage') {
        return;
      }

      if (context === 'dialog') {
        if (isListingPage()) {
          var listingTarget = urlWithVehicle(new URL(window.location.href), nextState).toString();
          closeDialog();
          window.location.assign(listingTarget);
        } else {
          closeDialog();
        }
        return;
      }

      var target = new URL(form.getAttribute('data-results-url') || config.resultsUrl || '/collections/best-sellers-main', window.location.origin);
      window.location.assign(urlWithVehicle(target, nextState).toString());
    });
  }

  function bindForms() {
    document.querySelectorAll('[data-thq-vehicle-form]').forEach(bindForm);
  }

  function lockPageScroll() {
    if (document.body.classList.contains('thq-vehicle-dialog-open')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.setProperty('--thq-dialog-scroll-top', '-' + lockedScrollY + 'px');
    document.documentElement.classList.add('thq-vehicle-dialog-open');
    document.body.classList.add('thq-vehicle-dialog-open');
  }

  function unlockPageScroll() {
    var wasLocked = document.body.classList.contains('thq-vehicle-dialog-open');
    document.documentElement.classList.remove('thq-vehicle-dialog-open');
    document.body.classList.remove('thq-vehicle-dialog-open');
    document.body.style.removeProperty('--thq-dialog-scroll-top');
    if (wasLocked && typeof window.scrollTo === 'function') window.scrollTo(0, lockedScrollY);
  }

  function openDialog(trigger) {
    var dialog = document.querySelector('[data-thq-vehicle-dialog]');
    if (!dialog) return;
    lastDialogTrigger = trigger || document.activeElement;
    syncForms(loadState());
    lockPageScroll();
    dialog.hidden = false;
    dialog.scrollTop = 0;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var closeButton = dialog.querySelector('.thq-vehicle-dialog__close');
    var firstSelect = dialog.querySelector('[data-thq-vehicle-make]');
    var focusTarget = isMobile ? closeButton : firstSelect;
    if (focusTarget) window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 20);
  }

  function closeDialog() {
    var dialog = document.querySelector('[data-thq-vehicle-dialog]');
    if (!dialog) {
      unlockPageScroll();
      return;
    }
    var wasOpen = !dialog.hidden;
    dialog.hidden = true;
    unlockPageScroll();
    if (wasOpen && lastDialogTrigger && typeof lastDialogTrigger.focus === 'function') {
      lastDialogTrigger.focus({ preventScroll: true });
    }
  }

  function clearVehicle() {
    storeState(null);
    saveVehicleToCart(null);
    syncInterface(null);
    document.querySelectorAll('[data-thq-vehicle-feedback]').forEach(function (feedback) {
      feedback.textContent = '';
      feedback.classList.remove('is-success');
    });
    closeDialog();

    if (isListingPage()) {
      window.location.assign(urlWithoutVehicle(new URL(window.location.href)).toString());
    } else {
      var status = document.querySelector('[data-thq-vehicle-filter-status]');
      if (status) status.remove();
    }
  }

  function hideUniversalFilterControls(root) {
    if (!UNIVERSAL_ENABLED) return;
    var scope = root || document;
    scope.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      if (normalize(input.value) !== normalize(UNIVERSAL)) return;
      var item = input.closest('li');
      if (item) item.hidden = true;
    });

    scope.querySelectorAll('.tag-list--active-tags li').forEach(function (item) {
      var label = item.querySelector('a');
      if (label && normalize(label.textContent) === normalize(UNIVERSAL)) item.hidden = true;
    });
  }

  function bindGlobalActions() {
    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-thq-open-vehicle-dialog]');
      if (openButton) {
        event.preventDefault();
        openDialog(openButton);
        return;
      }

      if (event.target.closest('[data-thq-close-vehicle-dialog]')) {
        event.preventDefault();
        closeDialog();
        return;
      }

      if (event.target.closest('[data-thq-clear-vehicle]')) {
        event.preventDefault();
        clearVehicle();
        return;
      }

      var expandHomeSelector = event.target.closest('[data-thq-home-mobile-expand]');
      if (expandHomeSelector) {
        event.preventDefault();
        var homeSection = expandHomeSelector.closest('[data-thq-vehicle-selector-home]');
        if (!homeSection) return;
        homeSection.classList.add('is-mobile-expanded');
        expandHomeSelector.setAttribute('aria-expanded', 'true');
        var makeSelect = homeSection.querySelector('[data-thq-vehicle-make]');
        if (makeSelect) window.setTimeout(function () { makeSelect.focus(); }, 20);
        return;
      }

    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDialog();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('form[role="search"]') || !form.querySelector('input[name="q"]')) return;
      var state = loadState();
      var details = stateDetails(state);
      if (!details) return;

      form.querySelectorAll('[data-thq-vehicle-search-input]').forEach(function (input) { input.remove(); });
      [
        { name: config.makeParam, values: details.makeFilterValues },
        { name: config.modelParam, values: details.modelFilterValues }
      ].forEach(function (field) {
        if (!field.name) return;
        field.values.forEach(function (value) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = field.name;
          input.value = value;
          input.setAttribute('data-thq-vehicle-search-input', '');
          form.appendChild(input);
        });
      });
    }, true);
  }

  function addFilterStatus(state) {
    if (!isListingPage() || document.querySelector('[data-thq-vehicle-filter-status]')) return;
    var details = stateDetails(state);
    if (!details) return;

    var currentUrl = new URL(window.location.href);
    var inferred = inferStateFromUrl(currentUrl);
    if (!inferred || inferred.makeId !== state.makeId || inferred.modelId !== state.modelId) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'page-width thq-vehicle-filter-status';
    wrapper.setAttribute('data-thq-vehicle-filter-status', '');

    var inner = document.createElement('div');
    inner.className = 'thq-vehicle-filter-status__inner';

    var copy = document.createElement('div');
    copy.className = 'thq-vehicle-filter-status__copy';
    copy.innerHTML = '<svg aria-hidden="true" viewBox="0 0 32 22"><path d="M2 15h2.4l1.8-7.2A2.4 2.4 0 0 1 8.5 6h9.8a2.4 2.4 0 0 1 2 1.1l3.1 4.9H27a3 3 0 0 1 3 3v2h-2.2a3.4 3.4 0 0 1-6.6 0H10.8a3.4 3.4 0 0 1-6.6 0H2v-2Z"/><circle cx="7.5" cy="17" r="1.7"/><circle cx="24.5" cy="17" r="1.7"/><path d="M7.5 8.5h10.3l2.2 3.5H6.6l.9-3.5Z"/></svg>';
    var message = document.createElement('span');
    message.className = 'thq-vehicle-filter-status__desktop-message';
    var strong = document.createElement('strong');
    strong.textContent = 'Showing products for ' + details.label;
    message.appendChild(strong);
    message.appendChild(document.createTextNode(UNIVERSAL_ENABLED ? ' — universal-fit items included.' : '.'));
    copy.appendChild(message);

    var mobileVehicle = document.createElement('strong');
    mobileVehicle.className = 'thq-vehicle-filter-status__mobile-vehicle';
    mobileVehicle.textContent = details.label;
    copy.appendChild(mobileVehicle);

    var actions = document.createElement('div');
    actions.className = 'thq-vehicle-filter-status__actions';
    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'thq-vehicle-filter-status__change';
    change.textContent = 'Change';
    change.setAttribute('data-thq-open-vehicle-dialog', '');
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'thq-vehicle-filter-status__clear';
    clear.textContent = 'Clear';
    clear.setAttribute('data-thq-clear-vehicle', '');
    actions.appendChild(change);
    actions.appendChild(clear);

    inner.appendChild(copy);
    inner.appendChild(actions);
    wrapper.appendChild(inner);

    var main = document.getElementById('MainContent');
    if (main) main.insertBefore(wrapper, main.firstChild);
  }

  function initialize() {
    bindGlobalActions();
    bindForms();
    hideUniversalFilterControls(document);

    var currentUrl = new URL(window.location.href);
    var state = loadState();
    var hasMakeParam = config.makeParam && currentUrl.searchParams.has(config.makeParam);
    var hasModelParam = config.modelParam && currentUrl.searchParams.has(config.modelParam);

    if (isListingPage() && hasMakeParam && hasModelParam) {
      var urlState = inferStateFromUrl(currentUrl);
      if (urlState) {
        state = urlState;
        storeState(state);
        if (!urlHasCompleteVehicle(currentUrl, state)) {
          window.location.replace(urlWithVehicle(currentUrl, state).toString());
          return;
        }
      }
    } else if (isListingPage() && state && !hasMakeParam && !hasModelParam) {
      window.location.replace(urlWithVehicle(currentUrl, state).toString());
      return;
    }

    syncInterface(state);
    addFilterStatus(state);

    document.addEventListener('shopify:section:load', function () {
      bindForms();
      syncInterface(loadState());
      hideUniversalFilterControls(document);
    });
  }

  if (window.__THQ_VEHICLE_SELECTOR_TEST__) {
    window.TruckHQVehicleSelectorTest = {
      vehicles: VEHICLES,
      getState: getState,
      stateDetails: stateDetails,
      inferStateFromUrl: inferStateFromUrl,
      urlWithVehicle: urlWithVehicle,
      urlWithoutVehicle: urlWithoutVehicle,
      urlHasCompleteVehicle: urlHasCompleteVehicle
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
